var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgExclamationIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.37622 15.9961C12.5184 15.9961 15.8762 12.6382 15.8762 8.49609C15.8762 4.35396 12.5184 0.996094 8.37622 0.996094C4.23408 0.996094 0.876221 4.35396 0.876221 8.49609C0.876221 12.6382 4.23408 15.9961 8.37622 15.9961ZM8.37606 3.49609C8.92398 3.49609 9.36401 3.94801 9.3494 4.49574L9.23102 8.93497C9.21898 9.3864 8.84957 9.74609 8.39798 9.74609H8.35413C7.90255 9.74609 7.53313 9.3864 7.52109 8.93498L7.40272 4.49574C7.38811 3.94801 7.82814 3.49609 8.37606 3.49609ZM9.37606 12.4961C9.37606 13.0484 8.92834 13.4961 8.37606 13.4961C7.82377 13.4961 7.37606 13.0484 7.37606 12.4961C7.37606 11.9438 7.82377 11.4961 8.37606 11.4961C8.92834 11.4961 9.37606 11.9438 9.37606 12.4961Z",
    fill: "#FF6170"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgExclamationIcon);
export default __webpack_public_path__ + "static/media/ExclamationIcon.f740539af24e9e9fbab7824dadc9e110.svg";
export { ForwardRef as ReactComponent };